import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { loginFormData } from "../../pages/auth/schema/login.schema";
import { loginService } from "../../pages/auth/service/auth.service";

interface IAuthContexData {
  logout: () => void;
  estaAutenticado: boolean;
  login: (data: loginFormData) => Promise<string | void>;
}

const LoginContext = createContext<IAuthContexData>({} as IAuthContexData);

export const useAppLoginContext = () => {
  return useContext(LoginContext);
};

export function AuthProvider({ children }: { children: ReactNode }) {
  const [token, setToken] = useState<string>();

  useEffect(() => {
    const storedToken = localStorage.getItem("accessToken");
    if (storedToken) {
      setToken(storedToken);
    } else {
      setToken(undefined);
    }
  }, []);

  const handleLogin = useCallback(async (data: loginFormData) => {
    const result = await loginService.auth(data);
    if (result instanceof Error) {
      return result.message;
    } else {
      localStorage.setItem("accessToken", result.accessToken);
      localStorage.setItem("permissions", JSON.stringify(result.permissions));
      localStorage.setItem("idUserLogado", result.idUserLogado);
      localStorage.setItem("idCompany", result.idCompany)
      localStorage.setItem("avatar", result.avatar);
      localStorage.setItem("fullName", result.name);
      if (result?.companyConfig) {
        localStorage.setItem(
          "alicota",
          String(Number(result.companyConfig.alicota ?? 0))
        );

        localStorage.setItem(
          "cancelFinancialMovement",
          JSON.stringify(result.companyConfig.cancelFinancialMovement ?? false)
        );

        localStorage.setItem(
          "cancellationPeriod",
          JSON.stringify(result.companyConfig.cancellationPeriod ?? 0)
        );

        localStorage.setItem(
          "chargesClt",
          String(Number(result.companyConfig.filtTotalChargesPercent ?? 0))
        );
      }
      setToken(result.accessToken);
    }
  }, []);

  const handleLogout = useCallback(() => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("permissions");
    localStorage.removeItem("idUserLogado");
    localStorage.removeItem("idCompany");
    localStorage.removeItem("avatar");
    localStorage.removeItem("fullName");
    localStorage.removeItem("alicota");
    localStorage.removeItem("cancelFinancialMovement");
    localStorage.removeItem("cancellationPeriod");
    localStorage.removeItem("chargesClt");
    setToken(undefined);
  }, []);

  const estaAutenticado = useMemo(() => !!token, [token]);
  return (
    <LoginContext.Provider
      value={{ logout: handleLogout, estaAutenticado, login: handleLogin }}
    >
      {children}
    </LoginContext.Provider>
  );
}
